<template>
    <ModalBase :with-content="true" @close="closeModal">
        <loader :loading="saving || loading"></loader>
        <div class="modalContent">
            <span class="uppercase listTitle bold">{{ campaign.name }}</span>
            <h1>Edit campaign</h1>
            <form class="form_campaing">
                <div class="">
                    <div class="form-group row">
                        <label class="col-4 col-form-label label">{{ $t("editCampaign.name") }}</label>
                        <div class="col-8">
                            <input type="text" style="width: 100%" v-model.trim="campaign.name" :maxlength="MAX_LENGTH_NAME" minlength="5" />
                        </div>
                    </div>
                    <br />
                    <div class="form-group row">
                        <label class="col-4 col-form-label label">{{ $t("editCampaign.shortName") }}</label>
                        <div class="col-8"><input type="text" style="width: 100%" v-model.trim="campaign.shortName" maxlength="5" /></div>
                    </div>
                    <br />
                    <div class="form-group row">
                        <label class="col-4 col-form-label label">{{ $t("editCampaign.lastCampaign") }}</label>
                        <div class="col-8">
                            <select v-model="lastCampaign">
                                <option selected class="uppercase" :value="undefined"> {{ $trad.campaignCreate.previousCampaign }}</option>
                                <option :value="campaign.id" :key="campaign.id" v-for="campaign in campaigns"> {{ campaign.name }} </option>
                            </select>
                        </div>
                    </div>
                    <br />
                    <div class="form-group row">
                        <label class="col-4 col-form-label label">{{ $t("editCampaign.launch") }}</label>
                        <div class="col-8"><input style="width: 100%" type="date" v-model="campaign.launchDate" /></div>
                    </div>
                    <br />
                    <div class="form-group row">
                        <label class="col-4 col-form-label label">{{ $t("editCampaign.end") }}</label>
                        <div class="col-8"><input style="width: 100%" type="date" v-model="campaign.endDate" /></div>
                    </div>
                    <br />
                </div>
            </form>
        </div>
        <br />
        <br />
        <footer class="flexContainer">
            <RoundedButton :className="'block uppercase save'" :disabled="!canSave" @click="saveEditCampaign();">
                {{ $t("editCampaign.save") }}
            </RoundedButton>
            <RoundedButton :className="'block uppercase save'" @click="closeModal();"> {{ $t("common.cancel") }}</RoundedButton>
            <RoundedButton :className="'block uppercase'" v-if="hasAccessDelete('campaign_manager')" @click="deleteEditedCampaign();">
                {{ $t("editCampaign.delete") }}</RoundedButton
            >
        </footer>
    </ModalBase>
</template>

<script>
function deleteErrorCallback(e) {
    let errorMessage = e.response.status === 403 ? this.$t("editCampaign.warningText") : e;
    this.dialogError(errorMessage);
}
import TryLoadMixin, { TrySaveMixin } from "@/mixins/TryLoadMixin";
import RoundedButton from "@/catalog/components/rounded-button";
import ModalBase from "@/components/modal/ModalBase";
import loader from "@/components/loader/loader";
import { isValidNameLength } from "@/utils/string";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
    mixins: [TryLoadMixin, TrySaveMixin],
    data() {
        return {
            campaign: undefined,
            lastCampaign: undefined
        };
    },
    components: { RoundedButton, ModalBase, loader },
    methods: {
        ...mapActions("campaign/list", ["populateCampaignsList", "updateCampaign", "deleteCampaign"]),
        async saveEditCampaign() {
            let { id, name, shortName, launchDate, endDate } = this.campaign;
            let campaignEdited = {
                id,
                campaign: {
                    name,
                    shortName,
                    launchDate,
                    endDate: endDate || null,
                    lastCampaign: (this.lastCampaign && { id: this.lastCampaign }) || null
                }
            };
            await this.trySave(() => this.updateCampaign(campaignEdited));
            this.closeModal();
            this.dialogSuccess(this.$trad.editCampaign.updatedMessage);
        },
        async deleteEditedCampaign() {
            await this.trySave(() => this.deleteCampaign(this.campaign.id), e => deleteErrorCallback.call(this, e));
            this.dialogSuccess(this.$trad.editCampaign.deletedMessage);
            this.closeModal();
        },
        closeModal() {
            this.$emit("hideEditCampaign");
        }
    },
    computed: {
        ...mapState("campaign/list", ["campaigns"]),
        ...mapGetters("items", ["getEditCampaignObj"]),
        campaignNameIsCorrect() {
            return isValidNameLength(this.campaign.name);
        },
        canSave() {
            return this.campaignNameIsCorrect && this.campaign.launchDate;
        }
    },
    created() {
        this.campaign = { ...this.getEditCampaignObj };
        this.lastCampaign = (this.campaign.lastCampaign && this.campaign.lastCampaign.id) || undefined;
    }
};
</script>

<style lang="scss" scoped>
input {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
}

select {
    border: none;
    border-bottom: 1px solid #343434;
    width: 100%;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
}

footer {
    margin-left: 290px;

    .save {
        margin-right: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// EditCampaign.vue?6a5be9be